class CartDrawer extends HTMLElement {
  constructor() {
    super();
    const cart = this;
    const sections = this.getSectionsToRender().map((section) => section.id).join(',');
    fetch(`/?sections=${sections}`)
      .then((response) => response.json())
      .then((parsedState) => {
        cart.renderContents({ sections: parsedState }, true);
      });


    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    if (this.querySelector('#CartDrawer-Overlay')) {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('#cart-icon-bubble');

    for (const cartLink of cartLinks) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  updateRenderedSection(section, html) {
    const sectionTargets = Array.from(document.querySelectorAll(`[id="${section.id}"]`));

    if (!sectionTargets.length && section.selector) {
      const fallbackTarget = document.querySelector(section.selector);
      if (fallbackTarget) sectionTargets.push(fallbackTarget);
    }

    sectionTargets.forEach((target) => {
      const elementToReplace =
        section.selector && target.matches(section.selector)
          ? target
          : section.selector
            ? target.querySelector(section.selector) || target
            : target;
      elementToReplace.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });
  }

  renderContents(parsedState, dont_open = false) {
    this.waitForElement('.drawer__inner', () => {
      this.classList = parsedState.sections['cart-drawer'] != '' ? this.getCartClasses(parsedState.sections['cart-drawer']) : this.classList;
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        this.updateRenderedSection(section, parsedState.sections[section.id]);
      });
      if (!dont_open) {
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          this.open();
        });
      }
    });
  }
  waitForElement(selector, callback) {
    if (document.querySelector(selector)) {
      return callback();
    }
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        callback();
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  getCartClasses(html) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer').classList;
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return source ? source.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
